import React from 'react';
import {
  Box,
  Flex,
  H1,
  H2,
  Link,
  Typography,
  UL,
  spacing,
  useI18nContext,
} from '@procore/core-react';
import styled from 'styled-components';

const NoResultsWrapper = styled(Flex)`
  flex-direction: row;
  align-items: flex-start;
  gap: ${spacing.xl}px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const NoResults = () => {
  const i18n = useI18nContext();

  return (
    <NoResultsWrapper>
      <img
        src={window.imagePath('icons/Insights.svg')}
        alt="No Search Results"
      />
      <Flex direction="column" gap="sm">
        <Box marginBottom="xxl">
          <H1 style={{ marginBottom: `${spacing.md}px` }}>
            {i18n.t('noResults.title')}
          </H1>
          <Typography intent="body" className="color-concrete font-size-md">
            {i18n.t('noResults.description1')}
          </Typography>{' '}
          <br />
          <Typography intent="body" className="color-concrete font-size-md">
            {i18n.t('noResults.description2')}
          </Typography>
        </Box>
        <Box>
          <H2 style={{ marginBottom: `${spacing.md}px` }}>
            {i18n.t('noResults.suggestionsTitle')}
          </H2>
          <UL>
            <li className="color-concrete font-size-md">
              {i18n.t('noResults.browseCategories')}
            </li>
            <li className="color-concrete font-size-md">
              {i18n.t('noResults.visitCommunity')}{' '}
              <Link
                href="https://community.procore.com/s/topic/0TO2T000000c9HTWAY/integrations-app-marketplace"
                target="_blank"
              >
                {i18n.t('noResults.communityLink')}
              </Link>{' '}
              {i18n.t('noResults.communityDescription')}
            </li>
          </UL>
        </Box>
      </Flex>
    </NoResultsWrapper>
  );
};

export default NoResults;
